<template>
  <div>
    <HomeHeader @open-left="toMember"  />
    <HomeSwipeImg />
    <div
      class="home-notify-box"
      style="
        height: 40px;
        line-height: 40px;
        padding: 0px 15px;
        overflow: hidden;
        display: flex;
        flex-direction: row;
        align-items: center;
        margin: 9px 20px 15px;
        border-radius: 20px;
      "
    >
      <van-row style="width: 100%">
        <van-col :span="2" style="text-align: center"
          ><van-icon name="volume-o" size="20" 
        /></van-col>
        <van-col
          :span="20"
          style="
            font-size: 14px;
            height: 40px;
            line-height: 40px;
          "
        ><van-notice-bar
  :text="tmpNotify"
/>
        </van-col>
        <van-col :span="2" style="text-align: center"
          ><van-icon name="apps-o" size="20" 
        /></van-col>
      </van-row>
    </div>
    <HomeSwipeItem :datalst="dataLst" />
    <div class="toAccount">
      <div style="color: #00e6ff; font-size: 24px; margin: 20px">
        {{ $t('recharge.title') }}/{{ $t('withdrawal.title') }}
        <van-icon name="arrow" />
      </div>
      <p style="margin-left: 20px;" class="home-font">{{ $t('home.accountcenter') }}</p>
    </div>
    <HomeRanking :datalst="dataLst" />
    <AboutUsView />
    <ToRegisterView v-if="show2" />
    <Footer />
    <van-popup v-model="show1">
      <MemberInfo ref="memberinfo" @close-left="show1=false" />
    </van-popup>
  </div>
</template>

<script>
import { HomeHeader, HomeSwipeImg, HomeSwipeItem,HomeRanking,AboutUsView,ToRegisterView,MemberInfo } from './components/index'
import { getToken } from '@/utils/cookies'
import Footer from "@/components/Footer/index.vue";
export default {
  name: 'HomeView',
  components: {
    HomeHeader,
    HomeSwipeImg,
    HomeSwipeItem,
    HomeRanking,
    AboutUsView,
    Footer,
    ToRegisterView,
    MemberInfo
  },
  data () {
    return {
      show: false,
      show1:false,
      show2: false,
      timer: null,
      dataLst: [],
      tmpNotify:null
    }
  },
  inject: ['app'],
  computed: {
    safeWapConfig () {
      return this.app.wapConfig || {}
    }
  },
  created () {
    if (sessionStorage.getItem('cachedData')) {
      this.show = JSON.parse(sessionStorage.getItem('cachedData'))
    }
    if (!getToken()) {
      this.show2 = true
    }
    this.tmpNotify = this.$t('other.welcome',{name:this.safeWapConfig.name})
  },
  watch: {
    show1: {
      handler (newVal) {
        sessionStorage.setItem('cachedData', JSON.stringify(newVal))
        if (newVal && this.$refs.memberinfo)
          this.$refs.memberinfo.getMemberInf()
      },
      deep: true // 深度监听对象/数组变化
    }
  },
  mounted () {
    if (!getToken()) {
      this.show = false
    }
    this.getData()
    const that = this
    this.$nextTick(() => {
      that.timer = setInterval(() => {
        that.getData()
      }, 10000)
    })
    this.getNotice()
  },
  beforeDestroy () {
    if (this.timer) clearInterval(this.timer)
  },
  methods: {
    getNotice() {
      const token = getToken();
      const pageName = this.$route.name;
      if (token && token.length > 0 && pageName != "notify" && !this.show) {
        this.getNoticeList();
      }
    },
    async getNoticeList() {
      await this.$http({
        method: "post",
        url: "getNoticeList",
        data: {
          page: 1,
          limit: 1,
        },
      }).then((res) => {
        if (res.data && res.data.list && res.data.list.length > 0) {
          this.show = res.data.list[0].status == 1;
          this.tmpNotify = res.data.list[0].content;
        }
      });
    },
    toMember () {
      const token = getToken()
      if (token && token.length > 0) {
        this.show1 = true
        const that = this
        this.$nextTick(() => {
          that.$refs.memberinfo.getMemberInf()
        })
      } else {
        this.$router.push(
          {
            name: 'login'
          },
          () => {}
        )
      }
    },
    async getData () {
      await this.$http({
        method: 'post',
        url: 'getMarketList'
      }).then(res => {
        if (res && res.data && res.data.list) this.dataLst = res.data.list
      })
    },
    
  }
}
</script>
<style  scoped>
.toAccount {
  width: 100%;
  height: 110px;
  background-image: url(../../assets/22052203.0a19009e.png);
  background-size: 108% 100%;
  background-repeat: no-repeat;
  background-position: center;
  padding-top: 10px;
}

</style>
